import { CalendarMonthOutlined, FmdGoodOutlined, ChatBubbleOutlineOutlined } from '@mui/icons-material'
import { Grid, Typography, List, ListItem, Button, Chip, Skeleton } from '@mui/material'
import React from 'react'
import { KaziAvatar } from '../../../Shared Components/Kazi/KaziAvatar'
import { KaziBookmark } from '../../../Shared Components/Kazi/KaziBookmark'
import { getPayRate } from '../../../Utils/String'

export const JobPostingSkeleton = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid container display={"flex"} flexDirection={"row"} sx={{color: 'primary.main'}} columnGap={15}>
            <Grid item flex={1} display={"flex"} flexDirection={"column"} gap={4}>
                <Grid item display={"flex"} flexDirection={"column"} gap={'16px'}>
                    <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                        <Skeleton variant='rectangular' sx={{width: "178px", height:"24px"}}/>
                    </Grid>
                    <Grid item display={"flex"} flexDirection={"row"} gap={1}>               
                        <Skeleton variant='rectangular' sx={{width: "178px", height:"24px"}}/>
                    </Grid>
                    <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                        <Skeleton variant='rectangular' sx={{width: "178px", height:"24px"}}/>
                    </Grid>
                </Grid>
                <Grid item display={"flex"} flexDirection={"column"} >
                    <Skeleton variant='rectangular' sx={{width: "100px", height:"30px", marginBottom: "16px"}}/>
                    <Skeleton variant='rectangular' sx={{width: "640px", height:"174px"}}/>
                </Grid>
                <Grid item display={"flex"} flexDirection={"column"} >
                    <Skeleton variant='rectangular' sx={{width: "100px", height:"30px", marginBottom: "16px"}}/>
                    <Skeleton variant='rectangular' sx={{width: "640px", height:"174px"}}/> 
                </Grid>
                <Grid item display={"flex"} flexDirection={"column"} >
                    <Skeleton variant='rectangular' sx={{width: "100px", height:"30px", marginBottom: "16px"}}/>
                    <Skeleton variant='rectangular' sx={{width: "640px", height:"174px"}}/>
                </Grid>
            </Grid>
        </Grid>
    )
}